
    // api环境变量，本地修改仅本地生效
    module.exports = "http://www.cjdropshipping.offline.pre.com/";
  